import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import LavvaDetailsWrapper from '../../../../../components/details-wrapper';
import { BinarySensorTypeInternal } from '../../../../../data-access/gql-types/graphql';
import { FloodControl } from '../../../components/channel/controls/binary-sensor/flood';
import { InputControl } from '../../../components/channel/controls/binary-sensor/input';
import { MovementControl } from '../../../components/channel/controls/binary-sensor/movement';
import { ReedControl } from '../../../components/channel/controls/binary-sensor/reed';
import { useChannelsStateStore } from '../../../store/channels-state';
import { ChannelBinarySensorStateType, ChannelBinarySensorType, ChannelType } from '../../../types';
import { SensorDetailsItem } from '../components/sensor-details-item';

type ChannelDetailsSensorProps = {
  channel: ChannelType;
};

const ChannelDetailsBinarySensor: React.FC<ChannelDetailsSensorProps> = ({ channel }) => {
  const { t: td } = useTranslation('channel-details');
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as ChannelBinarySensorStateType | null;
  const binarySensorType = (channel.data as ChannelBinarySensorType).sensorType;

  const tabs = [{ label: td('currently') }];

  const renderContent = () => {
    if (!state) return null;
    const value = state.value != null ? Boolean(state.value) : null;

    switch (binarySensorType) {
      case BinarySensorTypeInternal.Flood:
        return <FloodControl value={value} />;
      case BinarySensorTypeInternal.Movement:
        return <MovementControl value={value} />;
      case BinarySensorTypeInternal.ReedSwitch:
        return <ReedControl value={value} />;
      case BinarySensorTypeInternal.Input:
        return <InputControl value={value} />;
      default:
        return (
          <Stack direction="row" alignItems="center" justifyContent="center" padding="0 10px">
            <span className="sensor-control-box__status">{td('exalus.sensor.noData')}</span>
          </Stack>
        );
    }
  };

  return (
    <LavvaDetailsWrapper preventSwipeEvent tabs={tabs}>
      <div className="p-l-24 p-r-24">
        <SensorDetailsItem channel={channel}>{renderContent()}</SensorDetailsItem>
      </div>
    </LavvaDetailsWrapper>
  );
};

export default ChannelDetailsBinarySensor;
